import React, { useState } from "react";
import clientReviewImg1 from "../assets/images/page-titles/5.webp";
import { Link } from "react-router-dom";

function FAQ() {
  const [openAccordion, setOpenAccordion] = useState(0); // Default open: index 2
  const [openAccordionCandidates, setOpenAccordionCandidates] = useState(0); // Default open: index 2

  const toggleAccordion = (index) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };

  const toggleAccordionForCandidates = (index) => {
    setOpenAccordionCandidates(
      openAccordionCandidates === index ? null : index,
    );
  };

  const accordionDataForCPAFirms = [
    {
      title: "What types of firms and clients do you work with?",
      content:
        "We support small, medium, and large CPA firms across Australia. Our experience spans HNI clients, SMEs, and multinational businesses, so we understand the nuances of different industries and client types.",
    },
    {
      title: "What makes Inscape different from other outsourcing providers?",
      content:
        "Our team brings Big 4 experience and exposure to complex corporate and international tax matters. We combine advanced tax knowledge with bookkeeping, BAS/IAS, payroll, and administrative services, providing a single-source solution for all your accounting needs.",
    },
    {
      title: "Can we choose which services you handle for us?",
      content:
        "Yes. Services such as bookkeeping, BAS/IAS, payroll, tax returns, financial reporting, SMSF compliance, FBT, and tax planning are fully scope-based. You decide which services you want for which clients.",
    },
    {
      title: "Do you handle complex or multinational tax issues?",
      content:
        "Absolutely. We have experience with CFC provisions, foreign branches, thin capitalisation, Division 7A, CGT, CGT concessions, SBE, BRE, and advanced corporate tax planning — all while integrating standard services under one roof.",
    },
    {
      title: "Will the same resource handle our work consistently?",
      content:
        "FTE Model: Dedicated resource exclusively for your firm. Flexible Hours Model: Resource may support different clients at different times depending on workload.",
    },
    {
      title: "Can you support HNI or high-value clients?",
      content:
        "Yes. We have experience managing HNI clients and complex structures, ensuring tailored tax, reporting, and compliance services alongside regular accounting and administrative support.",
    },
    {
      title: "Do you provide support only during peak periods?",
      content:
        "No. While the Flexible Hours Model is ideal for seasonal peaks, the FTE Model provides year-round support across different clients, covering ongoing bookkeeping, tax, FBT, and reporting requirements.",
    },
    {
      title: "How do you ensure quality and compliance?",
      content:
        "Our team combines Big 4-level expertise with structured workflows, checklists, and internal reviews to ensure accuracy and compliance for every engagement.",
    },
    {
      title: "Can we adjust the hours or scope during the year?",
      content:
        "Yes. Flexible Hours engagements can scale up or down, and FTE engagements can be reviewed and adjusted in consultation with your firm.",
    },
    {
      title: "How do you charge for your services?",
      content:
        "Flexible Hours Model: Fixed monthly hours, cost based on usage. FTE Model: Dedicated full-time resource, fixed monthly fee including resourcing and margin.",
    },
    {
      title: "Can we combine both models?",
      content:
        "Yes. Many firms use a hybrid approach: a dedicated FTE for ongoing work plus Flexible Hours support during seasonal peaks or specific projects.",
    },
    {
      title: "Why choose Inscape Outsourcing?",
      content:
        "We offer end-to-end services under a single roof with a team experienced in both complex multinational tax and everyday accounting tasks. Our goal is to be an extension of your firm, delivering high-quality, reliable support across all client types and service lines.",
    },
  ];

  const accordionDataForFAQForCandidates = [
    {
      title: "Who can apply to work with Inscape Outsourcing?",
      content:
        "We welcome accounting and finance professionals at all levels, from graduates to experienced accountants. Familiarity with Australian accounting standards and tax compliance is highly valued.",
    },
    {
      title: "Is training provided?",
      content:
        "Yes. We provide structured onboarding, process guidance, and ongoing support, ensuring you can efficiently handle client engagements and compliance requirements.",
    },
    {
      title: "What skills or software knowledge is preferred?",
      content: `•	Accounting software such as Xero, MYOB, QuickBooks, or Class Super,
                •	Understanding of Australian tax and accounting standards,
                •	Strong organisational, communication, and problem-solving skills`,
    },
    {
      title: "Can I develop my career while working with Inscape Outsourcing?",
      content:
        "Yes. Our team gains exposure to diverse clients, including SMEs, HNIs, and multinational businesses, as well as complex Australian tax and accounting scenarios, providing excellent learning and growth opportunities.",
    },
  ];
  React.useEffect(() => {
    // Apply background images
    document.querySelectorAll(".bg-img")?.forEach((el) => {
      const img = el.querySelector("img");
      if (img) {
        const parent = el.parentElement;
        if (parent) {
          parent.style.backgroundImage = `url(${img.src})`;
          parent.style.backgroundSize = "cover";
          parent.style.backgroundPosition = "center";
          parent.classList.add("bg-img");
          if (el.classList.contains("background-size-auto")) {
            parent.classList.add("background-size-auto");
          }
        }
        el.remove();
      }
    });
  }, []);

  return (
    <>
      <section className="page-title-layout1 page-title-light bg-parallax bg-overlay text-center">
        <div className="bg-img">
          <img src={clientReviewImg1} alt="background" />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-6 offset-lg-3">
              <h1 className="pagetitle-heading">Help &amp; FAQs</h1>
              <nav>
                <ol className="breadcrumb justify-content-center mb-0">
                  <li className="breadcrumb-item">
                    <Link to={"/"}>Home</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Help &amp; FAQs
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </section>

      <section className="pb-80">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-8">
              <div className="text-block mb-50">
                <h5 className="text-block-title">For CPA Firms</h5>
                <div className="accordion" id="accordion1">
                  {accordionDataForCPAFirms.map((item, index) => (
                    <div
                      key={index}
                      className={`accordion-item ${
                        openAccordion === index ? "opened" : ""
                      }`}
                    >
                      <div
                        className="accordion-header"
                        onClick={() => toggleAccordion(index)}
                        style={{ cursor: "pointer" }}
                      >
                        <a
                          className="accordion-title"
                          onClick={(e) => e.preventDefault()}
                        >
                          {item.title}
                        </a>
                      </div>
                      <div
                        className={`collapse ${
                          openAccordion === index ? "show" : ""
                        }`}
                        style={{
                          maxHeight: openAccordion === index ? "500px" : "0",
                          overflow: "hidden",
                          transition: "max-height 0.3s ease",
                        }}
                      >
                        <div className="accordion-body">
                          <p>{item.content}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-8 offset-lg-4">
              <div className="text-block mb-50">
                <h5 className="text-block-title">FAQ – For Candidates</h5>
                <div className="accordion" id="accordion1">
                  {accordionDataForFAQForCandidates.map((item, index) => (
                    <div
                      key={index}
                      className={`accordion-item ${
                        openAccordion === index ? "opened" : ""
                      }`}
                    >
                      <div
                        className="accordion-header"
                        onClick={() => toggleAccordionForCandidates(index)}
                        style={{ cursor: "pointer" }}
                      >
                        <a
                          className="accordion-title"
                          onClick={(e) => e.preventDefault()}
                        >
                          {item.title}
                        </a>
                      </div>
                      <div
                        className={`collapse ${
                          openAccordionCandidates === index ? "show" : ""
                        }`}
                        style={{
                          maxHeight:
                            openAccordionCandidates === index ? "500px" : "0",
                          overflow: "hidden",
                          transition: "max-height 0.3s ease",
                        }}
                      >
                        <div className="accordion-body">
                          <p>{item.content}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default FAQ;
